"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var parameters_1 = __importDefault(require("@/config/parameters"));
var GeocodingService = /** @class */ (function () {
    function GeocodingService($httpService) {
        this.$httpService = $httpService;
        this.host = parameters_1.default.geocoding.host;
        this.apiKey = parameters_1.default.geocoding.apiKey;
        this.size = 15;
        this.layers = [
            GeocodingService.LOCALITY_LAYER,
            GeocodingService.REGION_LAYER
        ];
        this.reverse_size = 1;
        this.reverse_layers = [
            GeocodingService.COARSE_LAYER
        ];
    }
    GeocodingService.prototype.setLayers = function (layers) {
        this.layers = layers;
        return this;
    };
    GeocodingService.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    GeocodingService.ADDRESS_LAYER = 'address';
    GeocodingService.STREET_LAYER = 'street';
    GeocodingService.LOCALITY_LAYER = 'locality';
    GeocodingService.LOCALADMIN_LAYER = 'localadmin';
    GeocodingService.REGION_LAYER = 'region';
    GeocodingService.COUNTY_LAYER = 'county';
    GeocodingService.COARSE_LAYER = 'coarse'; // All administrative layers (all except address and street)
    GeocodingService.BOUNDARIES = {
        'ES': {
            min_lon: -9.79,
            max_lon: 5.27,
            min_lat: 36.0,
            max_lat: 47.6
        },
        'IT': {
            min_lon: 0.37,
            max_lon: 13.49,
            min_lat: 41.19,
            max_lat: 53.82
        },
        'HU': {
            min_lon: 13.16,
            max_lon: 27.48,
            min_lat: 43.10,
            max_lat: 51.63
        },
        'NO': {
            min_lon: 8.69,
            max_lon: 12.60,
            min_lat: 59.44,
            max_lat: 63.83
        }
    };
    return GeocodingService;
}());
exports.default = GeocodingService;
